// Module
var code = "<md-card class=\"sb-tile\" md-ink-ripple> <md-card-content class=\"sb-tile-content\" ng-transclude> </md-card-content> </md-card> ";
// Exports
var _module_exports =code;;
var path = '/var/lib/jenkins/workspace/Sablono_sb-bimtime_master/app/scripts/common/ui-elements/directives/sbTile/sb_tile.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;